import COUNTRY_LIST from './data/countries.json';
export const COUNTRIES = COUNTRY_LIST.map(country => ({
    key: country.code,
    label: `global.country.${country.code}`,
}));
